import React from 'react';
import NoInternet from '../../lottiefiles/nointernet.json';
import Placeholder from '../placeholder';
import SimpleButton from '../common/buttons/SimpleButton/SimpleButton';
const NoInternetPage = ({ onRetry }) => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-bodycolor p-6 text-center">
            <Placeholder
                animationData={NoInternet}
                height={'260px'}
                title='No Internet Connection'
                message='Please check your network and try again.'
            />
            {onRetry && (
                <SimpleButton
                    title={"Retry"}
                    buttonType={"primary"}
                    customClass={"rounded-xl"}
                    onClickEvent={onRetry}
                />
            )}
        </div>
    );
};

export default NoInternetPage;
